<script setup>
import { computed } from 'vue';
import Avatar from 'next/avatar/Avatar.vue';

const props = defineProps({
  avatarInfo: {
    type: Object,
    required: true,
  },
  size: {
    type: Number,
    default: 24,
  },
  duration: {
    type: Number,
    default: 1000,
  },
  progress: {
    type: Number,
    default: 0,
  },
});

// Calcular circunferência e stroke-dashoffset
const radius = computed(() => props.size / 2 + 2);
const circumference = computed(() => 2 * Math.PI * radius.value);
const strokeDashoffset = computed(() => {
  const offset = circumference.value - (props.progress / 100) * circumference.value;
  return offset;
});
</script>

<template>
  <div class="loading-avatar-wrapper">
    <svg class="progress-ring" :width="size + 8" :height="size + 8">
      <circle
        class="progress-ring__circle"
        :stroke-dasharray="`${circumference} ${circumference}`"
        :style="{ strokeDashoffset: strokeDashoffset }"
        stroke-width="2"
        fill="transparent"
        :r="radius"
        :cx="(size + 8) / 2"
        :cy="(size + 8) / 2"
      />
    </svg>
    <div class="avatar-container">
      <Avatar v-bind="avatarInfo" :size="size" />
    </div>
  </div>
</template>

<style scoped>
.loading-avatar-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: fit-content;
}

.progress-ring {
  position: absolute;
  top: -4px;
  left: -4px;
  transform: rotate(-90deg);
}

.progress-ring__circle {
  stroke: #1f93ff;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.1s linear;
}

.avatar-container {
  position: relative;
  z-index: 1;
}
</style>
